export default __webpack_public_path__ + "static/trustedIcon4-41661b45a99aa3eb029f4090c27a5132.png";